import { render } from "./ListFactures.vue?vue&type=template&id=32bb7b54&scoped=true"
import script from "./ListFactures.vue?vue&type=script&lang=js"
export * from "./ListFactures.vue?vue&type=script&lang=js"

import "./ListFactures.vue?vue&type=style&index=0&id=32bb7b54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb7b54"]])

export default __exports__